/**
 * 창업지원 관련 상수 및 데이터
 * StartupPage 컴포넌트에서 사용하는 콘텐츠를 중앙에서 관리합니다.
 */

/**
 * 창업지원 프로그램 섹션 데이터
 */
export const startupProgram = {
  sections: [
    {
      id: 1,
      title: '창업지원 프로그램 소개',
      content: [
        {
          text: '중구행복돌봄센터는 사회적경제 분야의 창업을 지원합니다.',
        },
        {
          text: '예비 창업자 및 초기 창업자를 위한 다양한 지원 프로그램을 제공하고 있습니다.',
        },
      ],
    },
    {
      id: 2,
      title: '지원 내용',
      content: [
        {
          text: '창업 컨설팅 및 멘토링',
        },
        {
          text: '사업계획서 작성 지원',
        },
        {
          text: '네트워킹 및 교육 프로그램',
        },
      ],
    },
    {
      id: 3,
      title: '문의',
      content: [
        {
          text: '창업지원 프로그램에 대한 자세한 내용은 센터로 문의해 주시기 바랍니다.',
        },
      ],
    },
  ],
};
